import React, { useState } from "react"

import MasonryItem from "@mui/lab/MasonryItem"
import { Typography } from "@mui/material"

// Gatsby
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const MasonryCard = ({ item }, index) => {
  const [hover, setHover] = useState(false) // Check why this works only when set twice on image and link?
  return (
    <MasonryItem key={item.title || index}>
      <Link
        to={item.comingSoon ? null : item.href}
        style={{
          display: `grid`,
          textDecoration: `none`,
          opacity: item.comingSoon ? 0.65 : 1,
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <GatsbyImage
          style={{
            gridColumn: `1 / span 1`,
            gridRow: `1 / span 1`,
          }}
          image={item.gatsbyImageData}
          alt={item.title || `image`}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        />
        {item.title && (
          <Typography
            variant="h3"
            className="journalTitle"
            sx={{
              gridColumn: `1 / span 1`,
              gridRow: `1 / span 1`,
              zIndex: 5,
              textAlign: `center`,
              margin: `auto auto`,
              fontWeight: `bold`,
              userSelect: `none`,
              padding: { xs: 1, sm: 1, md: 4 },
              fontSize: { xs: `2.5rem`, sm: `2.5rem`, md: `3.4rem` },
              color: hover
                ? `primary.main`
                : item.titleColor == `light`
                ? "titles.light"
                : `titles.main`,
            }}
          >
            {item.comingSoon ? "Coming Soon" : item.title}
          </Typography>
        )}
      </Link>
    </MasonryItem>
  )
}

export default MasonryCard
